import { useCallback, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { isIndicadorRole, isPjRole } from '@/config/routeAccess'
import { useBlocos } from '@/hooks/useBlocos'
import { useDealsStore } from '@/stores/useDealsStore'
import { BlocosFab } from './BlocosFab'
import { BlocosModal } from './BlocosModal'

const PUBLIC_PATH_PREFIXES = ['/login', '/p/', '/portal/']

function isPublicRoute(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}

export function BlocosShell() {
  const { pathname } = useLocation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const userRole = useAuthStore((s) => s.user?.role)
  const currentUserId = useAuthStore((s) => s.user?.id)
  const [open, setOpen] = useState(false)
  const blocos = useBlocos()
  const dealPanelOpen = useDealsStore(
    (s) => Boolean(s.selectedDeal) || s.dealDetailUiOpen || s.dealContractModalOpen,
  )

  const handleBlocosLoad = useCallback(() => {
    void blocos.loadBlocosPageData()
  }, [blocos.loadBlocosPageData])

  if (
    !isAuthenticated ||
    isPublicRoute(pathname) ||
    pathname === '/apresentacao' ||
    isPjRole(userRole ?? '') ||
    isIndicadorRole(userRole ?? '')
  ) {
    return null
  }

  return (
    <>
      {!dealPanelOpen && (
        <BlocosFab badgeCount={blocos.badgeCount} onClick={() => setOpen(true)} />
      )}
      <BlocosModal
        open={open}
        onClose={() => setOpen(false)}
        items={blocos.items}
        loading={blocos.loading}
        saving={blocos.saving}
        currentUserId={currentUserId}
        threadDetail={blocos.threadDetail}
        threadLoading={blocos.threadLoading}
        threadSaving={blocos.threadSaving}
        onLoad={handleBlocosLoad}
        onOpenThread={blocos.loadBlocoThread}
        onCloseThread={blocos.clearThread}
        onAdd={blocos.addBloco}
        labels={blocos.labels}
        labelsLoading={blocos.labelsLoading}
        onCreateLabel={blocos.addLabel}
        onComplete={(id) => void blocos.completeBloco(id)}
        onDelete={(id) => void blocos.removeBloco(id)}
        onSendThreadMessage={(id, body) => blocos.sendThreadMessage(id, { body })}
        onSaveThreadMembers={(id, memberUserIds) =>
          blocos.saveThreadMembers(id, { memberUserIds })
        }
        onUploadThreadAttachment={(id, file) => blocos.uploadThreadAttachment(id, file)}
        onAssignLabels={(id, labelIds) => void blocos.assignBlocoLabels(id, labelIds)}
      />
    </>
  )
}
